// extracted by mini-css-extract-plugin
module.exports = {"navbar":"NavBar_navbar__1ggLl","light-button":"NavBar_light-button__1_W9R","disabled":"NavBar_disabled__2JNrY"};